// extracted by mini-css-extract-plugin
export var active = "_gk-7";
export var blink = "_gk-8";
export var dropDownSelector = "_gk-4";
export var dropDownWrapper = "_gk-3";
export var fakeCursor = "_gk-6";
export var fontSizeButton = "_gk-9";
export var formQuillEditor = "_gk-0";
export var pressed = "_gk-a";
export var qlBlank = "_gk-1";
export var textFormattingToolbar = "_gk-2";
export var textToolbarOption = "_gk-5";